import axios from '@/axiosInstance'
import {ResponseType} from '@/types'
import {CreateUserGroupSchema, UpdateUserGroupSchema} from '@/features/user-groups/types'

// Get all user groups
export interface HttpGetUserGroupsOptions {
    params: {
        search?: string
        responseType?: ResponseType
    }
}
export const httpGetUserGroups = ({params}: HttpGetUserGroupsOptions) => {
    return axios.get('/user-groups', {params})
}

// Create a new user group
export type HttpCreateUserGroupOptions = {
    params?: {
        responseType: ResponseType
    }
    payload: CreateUserGroupSchema
}
export const httpCreateUserGroup = ({payload, params}: HttpCreateUserGroupOptions) => {
    return axios.post('/user-groups', payload, {params})
}

// Update an existing user group
export type HttpUpdateUserGroupOptions = {
    urlParams: {
        groupId: string
    }
    params?: {
        responseType: ResponseType
    }
    payload: UpdateUserGroupSchema
}
export const httpUpdateUserGroup = ({urlParams, payload, params}: HttpUpdateUserGroupOptions) => {
    return axios.patch(`/user-groups/${urlParams.groupId}`, payload, {params})
}

// Delete a user group
export type HttpDeleteUserGroupOptions = {
    urlParams: {
        groupId: string
    }
}
export const httpDeleteUserGroup = ({urlParams}: HttpDeleteUserGroupOptions) => {
    return axios.delete(`/user-groups/${urlParams.groupId}`)
}
